export const durationCondition = { contractMaxDuration: 36 };
